import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiGet } from '../api/client';

interface CampaignInfo {
  slug: string;
  title: string;
  subtitle: string;
  cta: string;
  image_url: string | null;
  image_url_desktop: string | null;
  link_url: string | null;
  action_type: string;
  game_public_id: string | null;
}

export function CampaignPage() {
  const { slug = '' } = useParams();
  const { t } = useTranslation('common');
  const [data, setData] = useState<CampaignInfo | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    void apiGet<CampaignInfo>(`/api/v1/campaigns/${encodeURIComponent(slug)}`)
      .then((row) => {
        if (!cancelled) setData(row);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (error) {
    return (
      <div className="page">
        <p>{t('comingSoon')}</p>
        <Link to="/" className="btn btn-ghost">
          {t('seeAll')}
        </Link>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="page">
        <div className="skeleton" style={{ minHeight: 220 }} />
      </div>
    );
  }

  return (
    <div className="page campaign-info-page">
      <Link to="/" className="btn btn-ghost btn-compact">
        ←
      </Link>
      {data.image_url ? (
        <img src={data.image_url} alt="" className="campaign-info-art" />
      ) : null}
      <h1>{data.title || data.slug}</h1>
      {data.subtitle ? <p className="muted-note">{data.subtitle}</p> : null}
      {data.game_public_id ? (
        <Link to={`/play/${data.game_public_id}`} className="btn btn-primary">
          {data.cta || t('heroCta')}
        </Link>
      ) : data.link_url?.startsWith('/') ? (
        <Link to={data.link_url} className="btn btn-primary">
          {data.cta || t('heroCta')}
        </Link>
      ) : null}
    </div>
  );
}
